module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("The")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Power")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("of")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtxt"
  }, [_vm._v("How This Old-Fashioned Virtue")]), _vm._v(" "), _c('p', {
    staticClass: "subtxt"
  }, [_vm._v("Can Improve Your Life")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-16"
  }), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("M.J. Ryan")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-17"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/cplogo_titlepage.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f31092","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePowerOfPatience-1.vue
// module id = 63
// module chunks = 0